Monitoring.Views ||= {}

class Monitoring.Views.ArrivalAlertsEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/arrival_alerts/arrival_alerts_edit"]

  events:
    'change #arrival-alert-name': 'onChangeName'
    'change #arrival-alert-description': 'onChangeDescription'
    'change #arrival-alert-recipients': 'onChangeRecipients'
    'change #arrival-alert-active': 'onChangeActive'
    'change #arrival-alert-start-date': 'onChangeStartDate'
    'change #arrival-alert-end-date': 'onChangeEndDate'
    'change #arrival-alert-topics': 'onChangeTopics'
    'change #arrival-alert-tags': 'onChangeTags'
    'change #arrival-alert-groups': 'onChangeGroups'
    'change #arrival-alert-subtypes': 'onChangeSubtypes'
    'change input[name=arrival-alert-ownership]': 'onChangeOwnership'
    'change #arrival-alert-authors': 'onChangeAuthors'
    'change #arrival-alert-excluded-authors': 'onChangeExcludedAuthors'
    'change #arrival-alert-locations': 'onChangeLocations'
    'change #arrival-alert-mentions': 'onChangeMentions'
    'change #arrival-alert-minimum-followers': 'onChangeMinimumFollowers'
    'change #arrival-alert-news-sources': 'onChangeNewsSources'
    'change #arrival-alert-sentiments': 'onChangeSentiments'
    'click #cancel': 'onClickCancel'
    'click #save': 'onClickSave'

  initialize: (@options = {}) ->
    @arrivalAlert    = @options.arrivalAlert
    @availableTopics = @options.availableTopics
    @availableTags   = @options.availableTags
    @availableGroups = @options.availableGroups
    @availableSubtypes = @options.availableSubtypes
    @availableSentiments = _.map(['negative', 'neutral', 'positive', 'missing'], (s) ->
      {
        name: I18n.t('monitoring.arrival_alerts.sentiments.' + s)
        code: s
      }
    )
    @currentUser = @options.currentUser

  render: =>
    @$el.html(@template(@))
    @initializeModal()
    @initializeToggle()
    @initializeDatepicker(@arrivalAlert.get('start_date'), @arrivalAlert.get('end_date'))
    @initializeChosen()
    @updateSaveButtonStatus()
    @

  initializeModal: ->
    @$el.find('#arrival-alert-edit').modal()

  initializeToggle: ->
    @$el.find('#arrival-alert-active').bootstrapToggle({
      # 'on' and 'off' options can be set here
    })

  initializeDatepicker: (startDate, endDate) ->
    @$el.find('#arrival-alert-start-date').datepicker({
      todayBtn: 'linked',
      autoclose: true,
    })
    if startDate
      @$el.find('#arrival-alert-start-date').datepicker('setDate', Date.create(startDate))

    @$el.find('#arrival-alert-end-date').datepicker({
      autoclose: true,
    })
    if endDate
      @$el.find('#arrival-alert-end-date').datepicker('setDate', Date.create(endDate))

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({width: '395px', enable_split_word_search:true, search_contains:true});

  updateSaveButtonStatus: =>
    if @allMandatoryFieldsAreFilled()
      @$el.find('#save').prop('disabled', false)
    else
      @$el.find('#save').prop('disabled', true)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled() and @descriptionIsFilled() and @recipientsIsFilled() and @startDateIsFilled()

  nameIsFilled: ->
    @$el.find('#arrival-alert-name').val().trim().length > 0

  descriptionIsFilled: ->
    @$el.find('#arrival-alert-description').val().trim().length > 0

  recipientsIsFilled: ->
    @$el.find('#arrival-alert-recipients').val().trim().length > 0

  startDateIsFilled: ->
    @$el.find('#arrival-alert-start-date').val().trim().length > 0

  onChangeName: (evt) ->
    @onChangeTextProperty('name')
    @updateSaveButtonStatus()

  onChangeDescription: (evt) ->
    @onChangeTextProperty('description')
    @updateSaveButtonStatus()

  onChangeRecipients: (evt) ->
    enteredRecipients = @$el.find('#arrival-alert-recipients').val().trim()
    recipientsAsArray = _.map(enteredRecipients.split(','), (r) -> r.trim())
    @arrivalAlert.set('recipients', recipientsAsArray)
    @updateSaveButtonStatus()

  onChangeActive: (evt) ->
    active = @$el.find('#arrival-alert-active').prop('checked')
    @arrivalAlert.set('active', active)

  onChangeStartDate: (evt) ->
    date = @$el.find('#arrival-alert-start-date').datepicker("getDate")
    @arrivalAlert.set('start_date', date)
    @updateSaveButtonStatus()

  onChangeEndDate: (evt) ->
    date = @$el.find('#arrival-alert-end-date').datepicker("getDate")
    @arrivalAlert.set('end_date', date)

  onChangeTopics: (evt) ->
    @onChangeMultiselectProperty('topics')

  onChangeTags: (evt) ->
    @onChangeMultiselectProperty('tags')

  onChangeGroups: (evt) ->
    @onChangeMultiselectProperty('groups')

  onChangeSubtypes: (evt) ->
    @onChangeMultiselectProperty('subtypes')

  onChangeOwnership: (evt) ->
    selectedOption = @$el.find("input[name=arrival-alert-ownership]:checked")
    @arrivalAlert.set('ownership', selectedOption.attr('value'))

  onChangeAuthors: (evt) ->
    @onChangeTextProperty('authors')

  onChangeExcludedAuthors: (evt) ->
    @onChangeTextProperty('excluded_authors')

  onChangeLocations: (evt) ->
    @onChangeTextProperty('locations')

  onChangeMentions: (evt) ->
    @onChangeTextProperty('mentions')

  onChangeMinimumFollowers: (evt) ->
    enteredProperty = @$el.find("#arrival-alert-minimum-followers").val()
    @arrivalAlert.set('min_followers', enteredProperty)

  onChangeNewsSources: (evt) ->
    @onChangeTextProperty('news_sources')

  onChangeSentiments: (evt) ->
    @onChangeMultiselectProperty('sentiments')

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#arrival-alert-#{propertyName.replace('_', '-')}").val().trim()
    asArray = _.map(enteredProperty.split(','), (r) -> r.trim())
    @arrivalAlert.set(propertyName, asArray)

  onChangeMultiselectProperty: (propertyName) ->
    selectedOptions = @$el.find("#arrival-alert-#{propertyName.replace('_', '-')} option:selected")
    enteredProperties = _.map(selectedOptions, (opt) -> opt.value)
    @arrivalAlert.set(propertyName, enteredProperties)

  onClickCancel: ->
    @trigger('cancel')

  onClickSave: ->
    errorOrValid = @arrivalAlert.validateFields()
    if errorOrValid == "VALID"
      @arrivalAlert.set('updated_at', new Date().toISOString())
      @arrivalAlert.set('last_updated_by', @currentUser)
      @$el.find('.saving').removeClass('invalid-fields').html('Saving...').show()
      @arrivalAlert.save({}, {
        success: (response) =>
          @$el.find('#arrival-alert-edit').modal('hide')
          @trigger('afterSave', @arrivalAlert)
        error: (model, response) =>
          errors = response?.responseJSON?.errors
          message = if errors?.length then errors.join(', ') else 'Error'
          @$el.find('.saving').addClass('invalid-fields').html(message).show()
          console.log("Error saving alert: #{message}")
      })
    else
      @$el.find('.saving').addClass('invalid-fields').html(errorOrValid).show()
